/**
 * System Forms - Psychology / emotional therapy clinics
 *
 * Read-only forms for psychology, psychotherapy, emotional therapy and
 * clinical social work clinics (incl. CBT-oriented practices).
 */

const PSYCH_CLINIC_TYPES = [
  "psychology",
  "emotional_therapy",
  "clinical_social_work",
  "couples_counseling",
];

const tag = (field, label) =>
  `<span class="patient-field-placeholder" data-field="${field}" contenteditable="false">{${label}}</span>`;

const clientSignature =
  `<div class="signature-placeholder" data-signature-id="1" contenteditable="false"><div class="signature-line"></div><span class="signature-label">חתימה 1</span></div>`;

const signatureDate =
  `<span class="signature-date-placeholder" contenteditable="false">[תאריך חתימה]</span>`;

export const psychologistForms = [
  {
    id: "sys_form_cbt_treatment_agreement",
    name: "הסכם טיפול CBT (טיפול קוגניטיבי-התנהגותי)",
    content:
      `<h2 style="text-align:center;">הסכם טיפול קוגניטיבי-התנהגותי (CBT)</h2>` +
      `<p style="text-align:center;">${tag("clinicName", "שם הקליניקה")}</p>` +
      `<hr/>` +
      `<p>אני, ${tag("fullName", "שם מלא")}, ת.ז. ${tag("idNumber", "תעודת זהות")}, מאשר/ת כי הוסבר לי אופי הטיפול הקוגניטיבי-התנהגותי, ואני מסכים/ה להשתתף בו בהתאם לעקרונות הבאים:</p>` +
      `<h3>מהות הטיפול</h3>` +
      `<ul>` +
      `<li>הטיפול ממוקד, מובנה ומוגבל בזמן, ומתמקד בקשר שבין מחשבות, רגשות והתנהגויות.</li>` +
      `<li>בתחילת הטיפול נגדיר יחד מטרות טיפוליות ברורות ונעקוב אחר ההתקדמות לאורך הדרך.</li>` +
      `<li>הטיפול עשוי לכלול תרגול של מיומנויות, חשיפה הדרגתית למצבים מעוררי חרדה ושינוי דפוסי חשיבה.</li>` +
      `</ul>` +
      `<h3>שיתוף פעולה ומשימות בית</h3>` +
      `<ul>` +
      `<li>חלק מרכזי בטיפול הוא תרגול בין המפגשים (משימות בית, יומני מחשבות, תיעוד התנהגויות).</li>` +
      `<li>אני מבין/ה כי הצלחת הטיפול תלויה במידה רבה בהשתתפות פעילה ובביצוע המשימות המוסכמות.</li>` +
      `<li>אני מתחייב/ת לשתף את המטפל/ת בקשיים בביצוע המשימות כדי שנוכל להתאימן יחד.</li>` +
      `</ul>` +
      `<h3>מסגרת</h3>` +
      `<ul>` +
      `<li>מספר מפגשים משוער: <span class="free-text-placeholder" data-label="מספר מפגשים משוער" contenteditable="false">[טקסט חופשי: מספר מפגשים משוער]</span></li>` +
      `<li>תדירות המפגשים: <span class="free-text-placeholder" data-label="תדירות המפגשים" contenteditable="false">[טקסט חופשי: תדירות המפגשים]</span></li>` +
      `<li>מדיניות הביטולים והתשלומים של הקליניקה חלה על טיפול זה.</li>` +
      `<li>המידע הטיפולי חסוי, למעט מקרים המחייבים דיווח על פי דין או סכנה לחיים.</li>` +
      `</ul>` +
      `<hr/>` +
      `<p>אני מצהיר/ה כי קראתי והבנתי את האמור לעיל ומסכים/ה לתנאי הטיפול.</p>` +
      `<br/>` +
      `<p><strong>חתימת המטופל/ת:</strong></p>` +
      clientSignature +
      `<p><strong>תאריך:</strong> ${signatureDate}</p>`,
    isSystem: true,
    clinicTypes: PSYCH_CLINIC_TYPES,
  },
];
